import pictureAnimation from '@/scripts/animations/pictureAnimation';
import { qs } from '@/scripts/utils';

export default function picture(obj) {
  const el = obj.node;
  el.removeAttribute('data-anim');

  const picture = qs('div', el);
  const img = qs('img', el);

  const image = new Image();
  image.src = img.getAttribute('data-src');

  const imageHandler = () => {
    image.removeEventListener('load', imageHandler);

    img.removeAttribute('data-src');
    img.src = image.src;
    picture.style.backgroundImage = `url(${img.src})`;

    pictureAnimation(el);
  };

  image.addEventListener('load', imageHandler);
};